import * as React from 'react';

import { Button } from '@vimeo/iris/components';
import { Header } from '@vimeo/iris/typography';

import AuthModal from '../../../AuthModal';
import H2 from '../H2';
import { ButtonWrapper, Content, Description } from './index.styles';

interface BannerProps {
  buttonLabel: string;
  description: string;
  title: string;
}

export interface BannerState {
  showLoginForm: boolean;
}

const Banner = class extends React.Component<BannerProps, BannerState> {
  constructor(props: BannerProps) {
    super(props);
    this.state = {
      showLoginForm: false,
    };

    this.toggleLoginModal = this.toggleLoginModal.bind(this);
  }

  toggleLoginModal() {
    this.setState({ showLoginForm: !this.state.showLoginForm });
  }

  render() {
    const { description, title, buttonLabel } = this.props;
    const { showLoginForm } = this.state;

    return (
      <Content>
        <H2 type="primary">{title}</H2>
        <Description>
          <Header element="h1" size="3">
            {description}
          </Header>
        </Description>
        <AuthModal type="login" active={showLoginForm} dismiss={this.toggleLoginModal}>
          <ButtonWrapper>
            <Button
              size="lg"
              onClick={() =>
                window.devsite?.user ? window.location.assign('/apps/new') : this.toggleLoginModal()
              }
            >
              {buttonLabel}
            </Button>
          </ButtonWrapper>
        </AuthModal>
      </Content>
    );
  }
};

export default Banner;
